import { Chip } from '@nyce/admin-kit/ui';
import type { MonitorTestResult } from '../../api/monitors';
import { RowsTable } from './parts';

/** Rows per source of a test (`/{id}/test`, `/test-draft`): nothing is alerted or mailed. */
export function TestResultView({ result }: { result: MonitorTestResult }) {
  return (
    <div className="bm-test" data-testid="monitor-test-result">
      <p className="nyk-ui-hint">
        On system <b>{result.systemId}</b>. A test opens no alerts and sends no email.
      </p>
      {result.sources.map((s) => (
        <section key={s.label} className="bm-test-source" data-source={s.label}>
          <h3 className="nyk-inline">
            {s.label} <Chip size="sm">{s.type}</Chip>
            <Chip size="sm" className={s.success ? 'nyk-tone-green' : 'nyk-tone-red'}>
              {s.success ? `${s.rowCount} rows` : 'failed'}
            </Chip>
            {s.truncated && <Chip size="sm">truncated</Chip>}
          </h3>
          {s.error && <div className="bm-error">{s.error}</div>}
          {s.warnings?.length > 0 && (
            <ul className="bm-warnings">
              {s.warnings.map((w, i) => (
                <li key={i}>{w}</li>
              ))}
            </ul>
          )}
          {s.success && s.rows?.length > 0 && <RowsTable rows={s.rows} columns={s.columns} />}
          {s.success && !s.rows?.length && <p className="nyk-ui-hint">No rows: all clear.</p>}
        </section>
      ))}
    </div>
  );
}
